import { roleAssumptionReducer } from '@makemydeal/dr-activities-role-assumption';
import { roleAssumptionMiddleware } from './middleware';

export const roleAssumptionConfiguration = {
    middleware: roleAssumptionMiddleware,
    reducer: roleAssumptionReducer
};
